import type { CSSProperties } from "react";

export function getFlashcardProgressFillStyle(
  currentIndex: number,
  total: number,
): CSSProperties {
  const safeTotal = total <= 0 ? 1 : total;
  const pct = Math.min(100, Math.max(0, (currentIndex / safeTotal) * 100));
  return { width: `${pct}%` };
}
